import { cliBinaryManifestSchema } from "./schemas/http/cli-binary-manifest.js";
import * as z$1 from "zod/v4";
//#region src/cli-release.ts
const CLI_RELEASE_PATH = "/v1/cli/release";
const cliReleaseSchema = z$1.strictObject({ version: cliBinaryManifestSchema.shape.channels.shape.stable.shape.version });
//#endregion
export { CLI_RELEASE_PATH, cliReleaseSchema };

//# sourceMappingURL=cli-release.js.map